import soikieLogo from '~assets/soikie.png';
const CONFIGURATION = {
    name: 'Soikie',
    key: 'soikie',
    motto: 'Find the Perfect Tutor, Coach, or Sitter',
    logo: soikieLogo,
    linkPrivacyPolicy: 'https://soikie.com/privacy',
    linkTermsOfUse: 'https://soikie.com/terms',
};
export default CONFIGURATION;
